import {share} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {EfsReport, EfsReportClient} from './api.client';
import {Observable} from 'rxjs';

@Injectable()
export class EfsReportService {

  constructor(private _efsReportAPI: EfsReportClient) {
  }

  buildEfsReport(pledgeTypeId: string, agencyId: string): Observable<EfsReport[]> {
    return this._efsReportAPI.buildEfsReport(pledgeTypeId, agencyId).pipe(share());
  }
}
